/** `settings` namespace — Swedish (source of truth). */
const settings = {
  nav: {
    plugins: 'Plugins',
    organization: 'Organisation',
    project: 'Projekt',
    members: 'Medlemmar',
    profile: 'Profil',
    notifications: 'Aviseringar',
  },
  dialog: {
    title: 'Inställningar',
    description: 'Konto- och projektinställningar.',
    account: 'Konto',
    back: 'Tillbaka till inställningar',
    close: 'Stäng inställningar',
  },
  role: {
    owner: 'Ägare',
    admin: 'Admin',
    member: 'Medlem',
  },
  profile: {
    loading: 'Laddar profil...',
    title: 'Inställningar',
    description: 'Uppdatera namn och telefonnummer.',
    avatarAlt: 'Avatar',
    noImage: 'Ingen bild',
    avatarHint: 'Max 5 MB. JPG, PNG eller WEBP.',
    uploadImage: 'Ladda upp bild',
    uploading: 'Laddar upp…',
    avatarInvalidType: 'Endast JPG, PNG eller WEBP stöds.',
    avatarTooLarge: 'Avatarfilen är för stor (max 5 MB).',
    avatarUpdated: 'Avatar uppdaterad.',
    avatarUploadFailed: 'Kunde inte ladda upp avatar. Försök igen.',
    name: 'Namn',
    namePlaceholder: 'Ditt namn',
    phone: 'Telefon',
    phonePlaceholder: '+46 ...',
    language: 'Språk',
    languageHint: 'Språket för gränssnittet. Sparas på din profil.',
    theme: 'Tema',
    themeHint: 'Ljust, mörkt eller som systemet. Gäller den här enheten.',
    voice: 'Uppläsningsröst',
    voiceHint: 'Rösten när HUB läser upp ett svar. Gäller den här enheten.',
    speed: 'Uppläsningshastighet',
    speedHint: 'Gäller även uppläsning som redan spelas.',
    validation: 'Ange minst namn eller telefonnummer.',
    saved: 'Profil uppdaterad.',
    saveFailed: 'Kunde inte spara profilen. Försök igen.',
    saving: 'Sparar...',
    save: 'Spara profil',
  },
  browser: {
    title: 'Webbläsare',
    description:
      'HUB:s delade webbläsare kommer ihåg dina inloggningar (cookies) mellan sessioner, i alla projekt. Rensa dem om du vill logga ut överallt.',
    clear: 'Rensa sparade inloggningar',
    clearing: 'Rensar…',
    cleared: 'Sparade inloggningar rensade. Nästa webbläsarsession startar utloggad.',
    clearFailed: 'Kunde inte rensa. Försök igen.',
    confirmTitle: 'Rensa sparade inloggningar?',
    confirmDescription:
      'Du loggas ut från alla webbplatser i HUB:s webbläsare, i alla projekt. Nästa webbläsarsession startar utloggad.',
    cancel: 'Avbryt',
    confirm: 'Rensa',
  },
  push: {
    title: 'Aviseringar',
    description: 'Hantera hur du får aviseringar',
    webPush: 'Webbnotiser',
    webPushBody: 'Få aviseringar även när HUB inte är öppet i webbläsaren.',
    unsupported: 'Din webbläsare stöder inte webbnotiser.',
    enabled: 'Aktiverade ✓',
    disable: 'Avaktivera',
    disabling: 'Avaktiverar...',
    enable: 'Aktivera webbnotiser',
    enabling: 'Aktiverar...',
    test: 'Skicka testnotis',
    testing: 'Skickar...',
    testSent: 'Testnotis skickad – kolla din webbläsare.',
    testNoSubscriptions: 'Ingen prenumeration hittades på servern. Avaktivera och aktivera igen.',
    testFailed: 'Kunde inte skicka testnotisen. Försök igen.',
    notConfigured: 'Webbnotiser är inte konfigurerade på servern.',
    permissionDenied:
      'Webbläsaren nekade aviseringar. Tillåt aviseringar för HUB i webbläsarens inställningar.',
    subscribeFailed: 'Kunde inte aktivera webbnotiser. Försök igen.',
    unsubscribeFailed: 'Kunde inte avaktivera webbnotiser. Försök igen.',
  },
  members: {
    loading: 'Laddar medlemmar...',
    loadFailed: 'Kunde inte ladda medlemmar.',
    inviteTitle: 'Bjud in till projekt',
    emailLabel: 'E-postadress',
    emailPlaceholder: 'namn@företag.se',
    roleLabel: 'Projektroll',
    invite: 'Bjud in',
    inviting: 'Bjuder in...',
    added: 'Användaren har lagts till i projektet.',
    inviteSent: 'Inbjudan har skickats.',
    inviteFailed: 'Kunde inte bjuda in användaren.',
    removeFailed: 'Kunde inte ta bort medlemmen.',
    revokeFailed: 'Kunde inte återkalla inbjudan.',
    statusFailed: 'Kunde inte ändra status.',
    roleFailed: 'Kunde inte ändra roll.',
    resendFailed: 'Kunde inte skicka om inbjudan.',
    resent: 'Inbjudan har skickats igen.',
    title: 'Medlemmar',
    empty: 'Inga medlemmar ännu.',
    you: '(du)',
    disabled: 'Inaktiverad',
    guest: 'Gäst',
    enable: 'Aktivera',
    disable: 'Inaktivera',
    remove: 'Ta bort',
    pendingInvites: 'Väntande inbjudningar',
    invitedOn: 'Inbjuden {{date}}',
    resend: 'Skicka igen',
    revoke: 'Återkalla',
  },
  project: {
    creditCapTitle: 'Kredittak',
    creditCapBody:
      'Ett valfritt tak för hur många krediter det här projektet får använda av organisationens budget. Lämna tomt för inget tak.',
    creditCap: 'Tak (krediter)',
    creditCapNone: 'Inget tak',
    creditCapValue: '{{credits}} krediter',
    creditCapOrgLimit: 'Organisationens budget: {{credits}}',
    creditCapInvalid: 'Ange ett heltal från 1, eller lämna fältet tomt.',
    creditCapOwnerOnly: 'Endast projektägaren kan ändra taket.',
    appearance: 'Utseende',
    projectImage: 'Projektbild',
    selectedIcon: 'Vald ikon',
    defaultAppearance: 'Standardutseende',
    uploading: 'Laddar upp...',
    uploadImage: 'Ladda upp bild',
    removeImage: 'Ta bort',
    imageHint: 'JPEG, PNG eller WebP. Max 5 MB.',
    imageTooLarge: 'Bilden får vara max 5 MB.',
    imageInvalidType: 'Endast JPEG, PNG och WebP stöds.',
    uploadFailed: 'Kunde inte ladda upp bilden.',
    removeImageFailed: 'Kunde inte ta bort bilden.',
    pickIconWithImage: 'Välj ikon (visas när ingen bild är uppladdad)',
    pickIcon: 'Eller välj en ikon',
    details: 'Projektdetaljer',
    name: 'Projektnamn',
    description: 'Beskrivning',
    descriptionPlaceholder: 'Valfri beskrivning...',
    saved: 'Projektinställningar sparade.',
    saveFailed: 'Kunde inte spara ändringar.',
    meetingNotesTitle: 'Mötesanteckningar',
    meetingNotesBody:
      'Så här vill vi att HUB skriver mötesanteckningar. Instruktionerna läggs till i alla mötesanteckningar HUB skriver för projektet — den löpande sammanfattningen under ett HUB-möte, de färdiga anteckningarna efteråt och anteckningarna från inspelade Google Meet- och Teams-möten. Tomt = HUB:s vanliga sätt.',
    meetingNotesLabel: 'Instruktioner till HUB',
    meetingNotesPlaceholder:
      'T.ex. "Skriv kort och sakligt. Lista alltid beslut med ansvarig och datum. Använd rubrikerna Ekonomi, Tidplan och Arbetsmiljö när de är relevanta. Nämn aldrig namn på underentreprenörers anställda."',
    meetingNotesHint: '{{count}} / {{max}} tecken',
    saving: 'Sparar...',
    save: 'Spara',
    transferTitle: 'Flytta projekt',
    transferBody:
      'Flytta projektet till en annan organisation. Medlemmar som inte tillhör den nya organisationen kan förlora åtkomst.',
    targetOrg: 'Målorganisation',
    selectOrgPlaceholder: 'Välj organisation...',
    transfer: 'Flytta',
    noEligibleOrgs: 'Inga andra organisationer tillgängliga att flytta till.',
    transferConfirm:
      'Är du säker på att du vill flytta <strong>{{project}}</strong> till <strong>{{org}}</strong>? Medlemmar som inte tillhör den nya organisationen kan förlora åtkomst.',
    transferring: 'Flyttar...',
    transferSubmit: 'Flytta projekt',
    transferFailed: 'Kunde inte flytta projektet.',
    dangerZone: 'Riskzon',
    deleteTitle: 'Ta bort projekt',
    deleteBody:
      'Tar bort projektet permanent, inklusive alla chattar, dokument, ritningar och uppgifter. Detta går inte att ångra.',
    deleteButton: 'Ta bort projekt',
    deleteConfirm:
      'Skriv <strong>{{project}}</strong> för att bekräfta borttagningen. Alla data i projektet tas bort permanent.',
    deleting: 'Tar bort...',
    deletePermanently: 'Ta bort permanent',
    deleteFailed: 'Kunde inte ta bort projektet.',
  },
  organization: {
    creditsTitle: 'Krediter',
    creditsHint:
      'Använda krediter i den här perioden. Endast HUB-administratörer kan ändra kreditgränsen.',
    creditsMonthly: 'Perioden återställs {{date}}',
    creditsManual: 'Räknas tills en administratör nollställer',
    loading: 'Laddar...',
    loadFailed: 'Kunde inte ladda organisationsdata.',
    loadFailedGeneric: 'Kunde inte ladda organisation.',
    projectsWithLimit: 'Projekt (gräns: {{limit}})',
    totalMembers: 'Totalt antal medlemmar',
    authAny: 'Valfri',
    authMethod: 'Tvingad inloggningsmetod',
    settingsTitle: 'Inställningar',
    authHint: 'Denna inställning börjar gälla vid nästa inloggning.',
    saved: 'Inställningar sparade.',
    saveFailed: 'Kunde inte spara inställningar.',
    saving: 'Sparar...',
    save: 'Spara',
    membersTitle: 'Medlemmar',
    user: 'Användare',
    role: 'Organisationsroll',
    guest: 'Gäst',
    joined: 'Gick med',
    disabled: 'Inaktiverad',
    lastOwnerTooltip: 'Kan inte ändra rollen för den enda ägaren',
    guestAdminTooltip: 'Ägare och administratörer kan inte vara gäster',
    yes: 'Ja',
    no: 'Nej',
    enable: 'Aktivera',
    disable: 'Inaktivera',
    roleFailed: 'Kunde inte ändra roll.',
    statusFailed: 'Kunde inte ändra status.',
    guestFailed: 'Kunde inte ändra gäststatus.',
    membersHint: 'Nya medlemmar läggs till via projektinbjudningar.',
  },
  plugins: {
    intro:
      'Anslut externa MCP-servrar så att HUB kan använda deras verktyg i det här projektet. Varje plugin används av alla projektets medlemmar via HUB.',
    add: 'Lägg till MCP',
    empty: 'Inga plugins ännu.',
    emptyManager: 'Lägg till en MCP-server med dess URL — HUB visar vilka verktyg den har.',
    readOnly: 'Endast projektets ägare och administratörer kan ändra plugins.',
    notConfigured:
      'Plugins är inte konfigurerade på den här servern ännu (krypteringsnyckeln saknas). Kontakta HUB:s support.',
    loadFailed: 'Kunde inte ladda plugins.',
    status: {
      active: 'Aktiv',
      needs_auth: 'Väntar på auktorisering',
      needs_reauth: 'Behöver auktoriseras om',
      error: 'Fel',
      disabled: 'Avstängd',
    },
    toolCount_one: '{{count}} verktyg',
    toolCount_other: '{{count}} verktyg',
    showTools: 'Visa verktyg',
    hideTools: 'Dölj verktyg',
    noTools: 'Servern har inga verktyg.',
    toolUnavailable: 'ej tillgängligt (för långt namn)',
    authorizedBy: 'Auktoriserad av {{name}}, {{date}}',
    formerMember: 'tidigare medlem',
    apiKeyBy: 'API-nyckel tillagd av {{name}}, {{date}}',
    noAuth: 'Ingen inloggning',
    requiresAuth:
      'Servern kräver nu inloggning. Ta bort pluginet och lägg till det igen med en API-nyckel.',
    lastError: 'Senaste fel: {{error}}',
    lastUsed: 'Senast använd {{date}}',
    enabled: 'Aktiverad',
    actions: 'Åtgärder för {{name}}',
    refreshTools: 'Uppdatera verktyg',
    reauthorize: 'Auktorisera om',
    rename: 'Byt namn',
    remove: 'Ta bort',
    renameTitle: 'Byt namn på plugin',
    removeTitle: 'Ta bort {{name}}?',
    removeDescription:
      'HUB slutar använda pluginets verktyg direkt och sparade inloggningsuppgifter raderas. Det går inte att ångra.',
    cancel: 'Avbryt',
    save: 'Spara',
    saving: 'Sparar…',
    removed: 'Pluginet togs bort.',
    toolsRefreshed: 'Verktygen uppdaterades.',
    actionFailed: 'Det gick inte. Försök igen.',
    connected: 'Pluginet är anslutet.',
    connectFailed: 'Auktoriseringen slutfördes inte ({{code}}).',
    dialog: {
      title: 'Lägg till MCP-server',
      description: 'HUB ansluter till servern och läser vilka verktyg den har.',
      name: 'Namn',
      namePlaceholder: 't.ex. Linear',
      url: 'URL',
      urlPlaceholder: 'https://mcp.exempel.se/mcp',
      apiKey: 'API-nyckel (valfritt)',
      apiKeyToggle: 'Servern kräver en API-nyckel',
      apiKeyHint: 'Skickas som Authorization: Bearer … och sparas krypterad.',
      identityTitle: 'Delad identitet',
      identity:
        'Allt HUB gör i tjänsten görs som det konto du loggar in med eller vars nyckel du anger — även när en annan projektmedlem frågar, och även skrivningar som servern tillåter. Använd ett tjänstekonto eller ett konto vars åtkomst du vill dela med hela projektet.',
      oauthNote: 'Kräver servern inloggning skickas du vidare för att godkänna åtkomsten.',
      submit: 'Lägg till',
      submitting: 'Ansluter…',
      errors: {
        INVALID_URL:
          'Adressen är inte tillåten. Använd en publik https-adress utan inloggningsuppgifter.',
        LIMIT_REACHED: 'Ett projekt kan ha högst {{max}} plugins.',
        NOT_CONFIGURED: 'Plugins är inte konfigurerade på den här servern.',
        PROBE_FAILED: 'Kunde inte ansluta: {{message}}',
        unauthorized: 'Servern nekade anslutningen: {{message}}',
        FORBIDDEN: 'Endast projektets ägare och administratörer kan lägga till plugins.',
        generic: 'Kunde inte lägga till pluginet.',
      },
    },
  },
  roleInfo: {
    srLabel: 'Rollinformation',
    title: 'Organisationsroller',
    ownerTitle: 'Ägare (Owner)',
    ownerBody: 'Full kontroll. Kan skapa projekt, hantera alla medlemmar och inställningar.',
    adminTitle: 'Admin',
    adminBody: 'Kan skapa projekt. Kan inte ändra organisationsinställningar eller roller.',
    memberTitle: 'Medlem (Member)',
    memberBody: 'Standardåtkomst. Kan inte skapa projekt eller hantera andra medlemmar.',
    guestTitle: 'Gäst (Guest-flagga)',
    guestBody:
      'Gäster kan inte skapa projekt. De har tillgång enbart till projekt de blivit uttryckligen inbjudna till. Ägare och administratörer är aldrig gäster.',
  },
}

export default settings
